import React from "react"
import styled from "styled-components"

import { Device } from "../../types/contentfulTypes"
import DeviceCard from "../cards/DeviceCard"

interface Props {
  collections: Device[]
}

interface StyledProps {
  length: number
}

const CollectionCardList = (props: Props) => {
  const { collections } = props

  const length = collections?.length

  return (
    <Wrapper length={length}>
      {collections.map((collection, index) => {
        return (
          <DeviceCard
            key={index}
            title={collection?.name}
            image={collection?.image?.fields?.file?.url}
            slug={collection?.slug}
          />
        )
      })}
    </Wrapper>
  )
}

export default CollectionCardList

const Wrapper = styled.div<StyledProps>`
  position: relative;
  display: grid;
  grid-template-columns: repeat(${props => props.length}, 380px);
  justify-items: center;
  gap: 20px;
  padding: 100px 30px 40px;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`
